import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-098064fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "knowledge-related"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "knowledge-related-title" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Knowledge")
], -1))
const _hoisted_3 = {
  id: "relatedKnowledge",
  class: "related-knowledge"
}
const _hoisted_4 = ["href"]


export default /*#__PURE__*/_defineComponent({
  __name: 'knowledge-related',
  props: {
  knowledgeList: {
    type: Array as PropType<{ url: string; knowledgeName: string; knowledgeContent: string }[]>,
    default: () => [],
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (__props.knowledgeList?.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.knowledgeList, (list) => {
            return (_openBlock(), _createElementBlock("div", {
              key: list.url,
              class: "related-item"
            }, [
              _createElementVNode("a", {
                href: list.url
              }, _toDisplayString(list.knowledgeName), 9, _hoisted_4),
              _withDirectives((_openBlock(), _createElementBlock("p", null, [
                _createTextVNode(_toDisplayString(list?.knowledgeContent), 1)
              ])), [
                [_directive_dompurify_html, list.knowledgeContent]
              ])
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})